import type { SxProps } from '@mui/material'
import { Avatar, Box, Typography } from '@mui/material'
import type { Theme } from '@mui/material/styles'
import type { ReactNode } from 'react'
import React from 'react'

interface ListItemCardProps {
  icon: ReactNode
  iconBgColor?: string
  iconColor?: string
  text: string
  rightContent?: string | ReactNode
  rightContentBold?: boolean
  sx?: SxProps<Theme>
}

export const ListItemCard = ({
  icon,
  iconBgColor = 'info.light',
  iconColor = 'grey.600',
  text,
  rightContent,
  rightContentBold = true,
  sx,
}: ListItemCardProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      py={1}
      sx={{
        padding: '8px 16px',
        backgroundColor: 'grey.50',
        borderRadius: 2,
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderColor: 'grey.200',
        ...sx,
      }}
    >
      <Avatar variant="circular" sx={{ bgcolor: iconBgColor, color: iconColor }}>
        {icon}
      </Avatar>
      <Typography flex={1}>{text}</Typography>
      {rightContent &&
        (typeof rightContent === 'string' ? (
          <Typography fontWeight={rightContentBold ? 600 : 400}>{rightContent}</Typography>
        ) : (
          rightContent
        ))}
    </Box>
  )
}
